module.exports = __webpack_public_path__ + "media/images/faq/4-100-415dd6985bb927bb25364d3792165b30.jpg";